<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-trophy"
      texto-titulo="Listado de objetivos"
      :to-create-action="{name:'NuevoObjetivo'}"
      to-create-text="Nuevo objetivo"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList url="/objetivos" :fields="fields" :rowClick="verObjetivo"  ref="datatable"></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import DataList from "@/components/layouts/DataList";
export default {
  name: "ListarObjetivos",
  components: {
    TituloComponent,
    DataList,
    BlockUI
  },
  data() {
    return {
      objetivos: [],
      fields: [
        {
          name: "articulo.descripcion",
          label: "",
          type: "title",
          class: "",
          value: null
        },
        {
          name: "estado",
          label: "",
          type: "title",
          class: "text-success",
          prepend: '-'
        },
        {
          name: "cantidad",
          label: "Cantidad",
          type: "field",
          class: "text-alternate",
          value: null
        },
        {
          name: "desde",
          label: "Desde",
          type: "field",
          class: "",
          value: null
        },
        {
          name: "hasta",
          label: "Hasta",
          type: "field",
          class: "",
          value: null
        },
      ],
      loading: false
    };
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
      verObjetivo(objetivo){
          this.$router.push({name:'VerObjetivo', params:{id:objetivo.id}})
      }
  }
};
</script>